import React from 'react';
import { Leaf, Moon, ThermometerSnowflake, Soup, Activity, Heart, Brain, Sparkles, Flower2 } from 'lucide-react';
import { CTAButton } from './CTAButton';
const categories = [{
  icon: Activity,
  label: 'Inflamación y dolores',
  count: '42 remedios'
}, {
  icon: Moon,
  label: 'Ansiedad y sueño',
  count: '38 remedios'
}, {
  icon: ThermometerSnowflake,
  label: 'Resfriados y defensas',
  count: '35 remedios'
}, {
  icon: Soup,
  label: 'Digestión',
  count: '33 remedios'
}, {
  icon: Heart,
  label: 'Articulaciones y huesos',
  count: '29 remedios'
}, {
  icon: Brain,
  label: 'Estrés y cansancio',
  count: '31 remedios'
}, {
  icon: Sparkles,
  label: 'Piel y circulación',
  count: '28 remedios'
}, {
  icon: Flower2,
  label: 'Bienestar general',
  count: '40+ remedios'
}];
const sampleRemedies = [{
  title: 'Infusión de manzanilla y melisa',
  use: 'Relajación antes de dormir',
  time: '5 min'
}, {
  title: 'Compresa tibia de jengibre',
  use: 'Dolor muscular y articular',
  time: '10 min'
}];
export function InsideGuide() {
  return <section className="py-8 md:py-12 px-5 bg-cream-50" data-id="element-185">
      <div className="max-w-5xl mx-auto" data-id="element-186">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14 max-w-2xl mx-auto" data-id="element-187">
          <p className="text-xs uppercase tracking-[0.2em] text-olive-600 font-medium mb-4" data-id="element-188">
            Qué vas a encontrar adentro
          </p>
          <h2 className="font-serif font-medium text-3xl md:text-5xl text-ink-900 leading-tight mb-5" data-id="element-189">
            Más de 1,500 soluciones naturales,{' '}
            <span className="italic text-olive-600" data-id="element-190">
              a tu alcance en segundos
            </span>
          </h2>
          <p className="text-ink-700 text-base md:text-lg leading-relaxed font-medium" data-id="element-191">
            5 ebooks premium organizados por tema y por síntoma. Buscas lo que
            necesitas, encuentras la solución y sigues los pasos.
          </p>
        </div>

        {/* Categories grid */}
        <div className="mb-10 md:mb-14" data-id="element-192">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4" data-id="element-193">
            {categories.map((cat, idx) => {
            const Icon = cat.icon;
            return <div key={idx} className="bg-cream-100 border border-cream-300 rounded-2xl p-4 md:p-5 hover:border-olive-300 hover:shadow-md transition-all" data-id="element-194">
                  <div className="w-10 h-10 rounded-xl bg-olive-100 flex items-center justify-center mb-3" data-id="element-195">
                    <Icon className="w-5 h-5 text-olive-600" strokeWidth={1.8} data-id="element-196" />
                  </div>
                  <p className="font-serif text-sm md:text-base font-medium text-ink-900 leading-tight mb-1" data-id="element-197">
                    {cat.label}
                  </p>
                  <p className="text-xs text-ink-600" data-id="element-198">{cat.count}</p>
                </div>;
          })}
          </div>
        </div>

        {/* Sample remedy cards — reduced prominence */}
        <div className="mb-10 md:mb-14 max-w-3xl mx-auto" data-id="element-199">
          <p className="text-center text-sm font-medium text-ink-600 mb-6 uppercase tracking-wider" data-id="element-200">
            Ejemplos de lo que vas a encontrar
          </p>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-201">
            {sampleRemedies.map((r, idx) => <div key={idx} className="bg-cream-100 border border-cream-300 rounded-2xl p-4 flex items-center gap-4" data-id="element-202">
                <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-olive-600 flex items-center justify-center" data-id="element-203">
                  <Leaf className="w-5 h-5 text-cream-50" strokeWidth={1.8} data-id="element-204" />
                </div>
                <div className="flex-1" data-id="element-205">
                  <h4 className="font-serif font-medium text-ink-900 text-sm md:text-base leading-snug mb-0.5" data-id="element-206">
                    {r.title}
                  </h4>
                  <p className="text-xs text-ink-700" data-id="element-207">{r.use}</p>
                </div>
              </div>)}
          </div>
        </div>

        {/* Stats strip */}
        <div className="bg-olive-600 text-cream-50 rounded-3xl p-8 md:p-10 grid grid-cols-3 gap-4 text-center mb-8 md:mb-12" data-id="element-208">
          <div data-id="element-209">
            <p className="font-serif text-3xl md:text-5xl font-medium" data-id="element-210">
              1,500+
            </p>
            <p className="text-xs md:text-sm text-cream-200 mt-1" data-id="element-211">Soluciones</p>
          </div>
          <div className="border-x border-olive-500" data-id="element-212">
            <p className="font-serif text-3xl md:text-5xl font-medium" data-id="element-213">5</p>
            <p className="text-xs md:text-sm text-cream-200 mt-1" data-id="element-214">
              Ebooks premium
            </p>
          </div>
          <div data-id="element-215">
            <p className="font-serif text-3xl md:text-5xl font-medium" data-id="element-216">10</p>
            <p className="text-xs md:text-sm text-cream-200 mt-1" data-id="element-217">
              Bonos extra
            </p>
          </div>
        </div>

        <CTAButton data-id="element-218" />
      </div>
    </section>;
}